import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { Container, Row, Col } from "react-bootstrap";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";

import StudentAttendanceReportHome from "../components/student_attendance_report/attendanceReport";


const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
    }
  }
`;


class StudentAttendanceReport extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {

    const globals = this.props.globals;
    const loading1 = globals.loading;
    const error1 = globals.error;


    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }



    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />

        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>

          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>

            {
              loading1 ?
                (
                  <Container>
                    <Row>
                      <Col sm={12}>
                        <div class="spinner-border text-primary text-center loading-img-center"></div>
                      </Col>
                    </Row>
                  </Container>
                )
                :
                (
                  <Container fluid>
                    <StudentAttendanceReportHome globals={this.props.globals.globals}
                    />
                  </Container>
                )
            }
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}


export default withRouter(withApollo(
  compose(
    graphql(FETCH_GLOBALS, {
      options: (props) => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "globals",
    }),
  )(StudentAttendanceReport))
);


